// @flow

import React, { Component } from 'react';
import Responsive from '../responsive/Responsive';

type Props = {
  children: React.Node,
  desktop: number,
  mobile: number,
};

class Order extends Component<Props> {
  props: Props;
  static defaultProps = {};

  render() {
    const { desktop, mobile, children } = this.props;
    const child = React.Children.toArray(children)[0];
    if (!child) return null;
    return (
      <Responsive desktop>
        {isDesktop => React.cloneElement(child, { style: { order: isDesktop ? desktop : mobile } })}
      </Responsive>
    );
  }
}

export default Order;
